"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.slugify = exports.caseInsensitivelyEquals = void 0;
const lodash_1 = require("lodash");
exports.caseInsensitivelyEquals = (0, lodash_1.curry)((a, b) => a.toUpperCase() === b.toUpperCase());
function slugify(name) {
    return name
        .replace(/\/|{|}|\s/g, '-')
        .replace(/-{2,}/, '-')
        .replace(/^-/, '')
        .replace(/-$/, '');
}
exports.slugify = slugify;
//# sourceMappingURL=string.js.map